import axios from "axios";
import { displayPatientNameFromParts } from "../../../utils/displayPatientName";
import { formatAbhaNumberForHipLink } from "./UtilsFunctions";

export const getPatientYearOfBirth = (patientData) => {
  if (patientData?.year_of_birth != null && patientData?.year_of_birth !== "") {
    return Number(patientData.year_of_birth);
  }
  const dob = patientData?.dob;
  if (!dob) return null;
  const yearMatch = String(dob).match(/(\d{4})/);
  return yearMatch ? Number(yearMatch[1]) : null;
};

export const buildHipGenerateLinkTokenPayload = (patientData) => ({
  abhaNumber: formatAbhaNumberForHipLink(patientData?.abha_no),
  abhaAddress: patientData?.abha_id,
  name: displayPatientNameFromParts(patientData),
  gender: patientData?.gender?.substring?.(0, 1) || patientData?.gender || "",
  yearOfBirth: getPatientYearOfBirth(patientData),
});

export const isHipLinkTokenRefreshNeeded = (response) => {
  const message = String(
    response?.data?.message ?? response?.data?.error ?? response?.data?.status ?? "",
  ).toLowerCase();
  return (
    message.includes("token expired") ||
    message.includes("link token not available")
  );
};

const wait = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const postHipLinkCareContext = async ({
  backendUrl,
  postBody,
  headers,
  patientData,
}) => {
  const linkUrl = `${backendUrl}hip_link_carecontext/`;
  const tokenUrl = `${backendUrl}hip_generate_link_token/`;

  let response = await axios.post(linkUrl, JSON.stringify(postBody), { headers });

  if (isHipLinkTokenRefreshNeeded(response)) {
    const tokenPayload = buildHipGenerateLinkTokenPayload(patientData);
    await axios.post(tokenUrl, JSON.stringify(tokenPayload), { headers });
    await wait(2000);
    response = await axios.post(linkUrl, JSON.stringify(postBody), { headers });
  }

  return response;
};
